import React from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { InstructionsText, NavigationText } from "../Text";
import { Button } from "@mui/base";
import { BsArrowRight } from "react-icons/bs";

const Instructions: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useUser();

  const handleNext = () => {
    console.log(user.uuid);
    navigate(`/Objective/${user.uuid}`);
  };

  return (
    <>
      <div className="mt-6 font-sans text-UDig-gray flex flex-col space-y-4">
        <div>
          <h2 className="pb-1 border-b-2 border-UDig-orange px-1 font-bold text-UDig-orange text-xl">
            {InstructionsText.navigation.header}
          </h2>
          <div className="mt-2 p-6 rounded-md bg-white drop-shadow-lg">
            <div className="ml-1">{InstructionsText.navigation.body}</div>
          </div>
        </div>

        <div>
          <h2 className="pb-1 border-b-2 border-UDig-orange px-1 font-bold text-UDig-orange text-xl">
            {InstructionsText.forms.header}
          </h2>
          <div className="mt-2 p-6 rounded-md bg-white drop-shadow-lg">
            <div className="ml-1">{InstructionsText.forms.body}</div>
          </div>
        </div>

        <div>
          <h2 className="pb-1 border-b-2 border-UDig-orange px-1 font-bold text-UDig-orange text-xl">
            {InstructionsText.sessions.header}
          </h2>
          <div className="mt-2 p-6 rounded-md bg-white drop-shadow-lg">
            <div className="ml-1">{InstructionsText.sessions.body}</div>
          </div>
        </div>

        <div>
          <h2 className="pb-1 border-b-2 border-UDig-orange px-1 font-bold text-UDig-orange text-xl">
            {InstructionsText.contact.header}
          </h2>
          <div className="mt-2 p-6 rounded-md bg-white drop-shadow-lg">
            <div className="ml-1">{InstructionsText.contact.body}</div>
          </div>
        </div>
      </div>
      
      <div className="mt-4 mb-20 flex justify-end w-full">
        <Button
          className="flex items-center gap-x-2 text-UDig-orange"
          onClick={() => handleNext()}
        >
          {NavigationText.next}
          <BsArrowRight />
        </Button>
      </div>
    </>
  );
};

export default Instructions;
